<div class="actions content">
  <div class="float-left">
    <form [formGroup]="searchForm" fxLayout="column">
      <div fxLayoutAlign="space-between center">
        <mat-form-field appearance="outline" style="width: 120px;">
          <mat-label>Date Select</mat-label>
          <mat-select formControlName="date">
            <mat-option *ngFor="let dateOption of dateOptions" [value]="dateOption">
              {{dateOption.option}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div [formGroup]="rangeForm" *ngIf="isDateRangeEnabled">
          <mat-form-field appearance="outline" style="margin-left: 2px; width: 220px" >
            <mat-label>Enter Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="From date" formControlName="start" [value]="rangeStart" (dateChange)="onStartDateChange($event)" (keyup.enter)="onCustomDateFilterSelected()">
              <input matEndDate placeholder="To date" formControlName="end" [value]="rangeEnd" (dateChange)="onEndDateChange($event)" (keyup.enter)="onCustomDateFilterSelected()">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="onCustomDateFilterSelected()" >Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="float-right">
    <button *ngIf="!hideFilter" mat-stroked-button type="button" [disabled]="isFilterCreatorEnabled" (click)="enableFilterCreator()">
      <mat-icon inline="true">filter_list</mat-icon>
      Filter
    </button>
  </div>
  <div class="clear"></div>
  <ng-content></ng-content>
  <div class="clear"></div>
  <div class="d-flex">
    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="isFilterCreatorEnabled">
      <app-filter-creator
        [filterFactories]="filterFactories"
        (filterCreated)="filterCreated($event)"
      ></app-filter-creator>
      <button class="float-right" mat-stroked-button type="button" (click)="disableFilterCreator()">
        Cancel
      </button>
    </div>
  </div>
  <div class="d-flex">
    <mat-chip-list aria-label="Applied filters" *ngIf="filters.length > 0">
      <mat-chip *ngFor="let filter of filters.controls; let index = index;">
        <strong>{{filter.value.field}}</strong>&nbsp;{{filter.value.operator}}&nbsp;<strong>{{filter.value.criteria}}</strong>
        <button mat-icon-button (click)="removeFilter(index)">&times;
        </button>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
